import { EJReportTypeItem } from './EJReportTypeItem'

export const ConcreteTest = new EJReportTypeItem({
  id: '36250DE3-3C9A-4846-8D2E-0609805CC3D0',
  classType: 'ConcreteTest',
  label: 'testId',
  type: 'Concrete Test',
})

export const ConcretePlacement = new EJReportTypeItem({
  id: '6BBB49EA-B12D-46C1-B126-9B2BB5A5F519',
  classType: 'ConcretePlacement',
  label: 'placementId',
  type: 'Concrete Placement',
})

export const DensityLot = new EJReportTypeItem({
  id: '5EA7B116-FF6D-4F96-9D15-C461FFDE821D',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
})

export const DailyInspectionControlPoint = new EJReportTypeItem({
  id: '47E265EA-EE5E-42E1-84E5-32D8C5421E9C',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
})

export const DailyInspectionInspection = new EJReportTypeItem({
  id: '4939892D-E5EC-4D3B-89F4-B4665A709D91',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
})

export const Gradation = new EJReportTypeItem({
  id: 'AA2B6A6E-E902-4B10-8EC7-5013EBFA77F1',
  classType: undefined,
  label: undefined,
  type: 'Gradation',
})
